import { useInfiniteQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { useDebounce } from '@/hooks/ui/use-debounce'
import type { InfinityQueryData } from '@/types/inifity-query/infinity-query-data'

interface useSearchSelectProps {
  queryFn: (pageParam: number, term: string) => Promise<InfinityQueryData>
  queryKey: string[]
}

export const useSearchSelect = ({
  queryFn,
  queryKey
}: useSearchSelectProps) => {
  const [term, setTerm] = useState('')
  const termDebounce: string = useDebounce(term, 500)

  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status,
    isError
  } = useInfiniteQuery({
    queryKey: [...queryKey, termDebounce],
    queryFn: ({ pageParam }) => {
      return queryFn(pageParam, termDebounce)
    },
    getNextPageParam: (lastPage) => lastPage.pagination.nextPage,
    initialPageParam: 1
  })

  return {
    states: {
      data,
      hasNextPage,
      fetchNextPage,
      isFetching,
      isFetchingNextPage,
      status,
      error,
      isError,
      term
    },
    actions: {
      fetchNextPage,
      setTerm
    }
  }
}
